var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rich-text-field"},[_c('textarea',{ref:"field",staticClass:"form-control",attrs:{"disabled":_vm.disabled,"name":_vm.name,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"required":_vm.required},domProps:{"value":_vm.value}})])
}
var staticRenderFns = []

export { render, staticRenderFns }